module.exports = __webpack_public_path__ + "static/icon-school-89a51d784add2a8f08e88f8e785fa0f0.png";